// extracted by mini-css-extract-plugin
module.exports = {"CheckboxButton":"classes_CheckboxButton__3oqaq","buttonCheckBox2":"classes_buttonCheckBox2__1_C7-"};